<template>
  <b-input-group>

    <b-form-input v-model="value[lang]" />

    <template #append>
      <b-dropdown
        :text="lang"
        variant="outline-primary"
      >
        <b-dropdown-item
          v-for="item in languages"
          v-if="lang !== item"
          :key="item"
          @click="updateLang(item)"
        >
          {{ item }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </b-input-group>
</template>
<script>
import {
  BInputGroup, BFormInput, BDropdown, BDropdownItem,
} from 'bootstrap-vue'

export default {
  name: 'BFormInputLang',
  components: {
    BInputGroup,
    BFormInput,
    BDropdown,
    BDropdownItem,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      lang: 'uz',
    }
  },
  methods: {
    updateLang(lang) {
      this.lang = lang
    },
  },
  setup() {
    const languages = ['uz', 'ru', 'en']
    return {
      languages,
    }
  },
}
</script>

<style scoped>

</style>
